<template>
  <div>
    <div class="mb-3">
      <a-input v-model="search" placeholder="Zoeken">
      <a-icon slot="suffix" type="search" />
      </a-input>
    </div>
    <div v-if="reservations.length > 0">
    <div class="table-responsive" v-for="reservation in reservations">
      <table class="table"  :class="reservation.cancelled ? 'cancelled' : ''">
        <thead class="thead-light">
          <tr>
            <th style="width: 10%;" scope="col">Reservering</th>
            <th style="width: 20%;" scope="col">Naam</th>
            <th style="width: 17%;" scope="col">Auto</th>
            <th style="width: 10%;" scope="col">Vertrek</th>
            <th style="width: 10%;" scope="col">Aankomst</th>
            <th style="width: 10%;" scope="col">Prijs</th>
            <th style="width: 10%;" scope="col">Betaalmethode</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">
              {{(reservation.reserveringsnummer !== null) ? reservation.reserveringsnummer : reservation.id}}
              <br v-if="reservation.cancelled"/>
              <br v-if="reservation.cancelled"/>
              <a-tag v-if="reservation.cancelled" color="#c0392b">
                <b>Geannuleerd</b>
              </a-tag>
              <br/>
              <a-button @click="openReservation(reservation.id)" class="mt-3" type="primary">
                Bekijk
              </a-button>

            </th>
            <td>{{reservation.first_name}} {{reservation.last_name}}</td>
            <td>{{reservation.vehicle_make_model}} {{reservation.vehicle_color}} <br /> {{reservation.license_plate}}</td>
            <td>{{reservation.departure_flightnumber}} <br />{{moment(reservation.departure_time).format('DD-MM-YYYY HH:mm')}} </td>
            <td>{{reservation.arrival_flightnumber}} <br />{{moment(reservation.arrival_time).format('DD-MM-YYYY HH:mm')}}</td>
            <td >€ {{reservation.rate}}</td>
            <td>{{reservation.payment_method}} <br/> <a-tag v-if="reservation.payment_status === 'paid'" color="green">
        Betaald
      </a-tag>
      <a-tag v-if="reservation.payment_status === 'expired'" color="red">
        Mislukt
      </a-tag>
      </td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
    <div v-if="reservationsLoading"  class="w-100 d-flex justify-content-center align-items-center">
      <a-spin size="large" />
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    user: {
      get: function () {
        return this.$store.state.user
      },
    },
  },
  data() {
    return {
      search: undefined,
      reservations: [],
      reservationsLoading: true,
      page: 1,
    }
  },
  watch: {
    search: function(newVal) {
      this.reservations = []
      this.page = 1
      this.getReservations()
    },
  },
  mounted() {
    this.getReservations()
    this.scrollAdd()
  },
  destroyed() {
    this.scrollRemove()
  },
  methods: {
    openReservation(id) {
      this.$router.push({ name: 'singleReservation', params: { reservation_id: id } })
    },
    getReservations() {
      this.reservationsLoading = true
      this.$axios.get(`/reservations/all`, {
        params: {
          search_query: this.search ? this.search : null,
          page: this.page,
        },
        headers: {
          'Authorization': `Bearer ${this.user.user.token}`,
        } }).then(response => {
        this.reservationsLoading = false
        this.reservations = [...this.reservations, ...response.data.data]
        console.log('reservations', this.reservations)
      })
    },
    scroll() {
      if (((window.innerHeight + window.scrollY) >= document.body.scrollHeight)) {
        this.loadMorePosts()
      }
    },
    scrollAdd () {
      window.addEventListener('scroll', this.scroll)
    },
    scrollRemove() {
      console.log('scroll remove')
      window.removeEventListener('scroll', this.scroll)
    },
    loadMorePosts() {
      this.page++
      this.getReservations()
    },
  },
}
</script>
<style lang="scss">
.cancelled{
  background-color: lighten(#c0392b, 20%);
}
</style>
